module.exports = __webpack_public_path__ + "static/feature1-a345ee01b1a6d482dee0d2c160f64cf5.png";